import { types as t, Instance } from 'mobx-state-tree';
import Sensor from '~/mst/models/device/sensor';

const ParticlesPlusSensor = t
  .compose(
    t.model({
      units: t.frozen()
    }),
    Sensor
  )
  .named('ParticlesPlus');

export interface IParticlesPlusSensor extends Instance<typeof ParticlesPlusSensor> {}

export default ParticlesPlusSensor;
